<template>
  <div class="relative">
    <!-- <div v-if="getMonthlyChange()" class="w-full bg-black text-center">
      <p class="text-white">
        Kata sandi Anda akan segera kadaluwarsa,
        <a href="#" class="font-semibold" @click="activePrompt2 = true"
          >Ganti Sekarang -></a
        >
      </p>
      <vs-popup
        color="danger"
        title="Kata Sandi Anda Kadaluwarsa"
        :active.sync="activePrompt1"
        button-close-hidden
        @close="closePopup"
        ><div>
          <div class="flex flex-col mb-5" style="gap: 10px">
            <img
              class="w-1/3"
              src="@/assets/images/kadaluwarsa.png"
              alt="bg"
              style="place-self: center" />
            <p>
              Kata sandi Anda kadaluwarsa. Harap perbarui kata sandi Anda segera
              untuk menjaga keamanan akun Anda.
            </p>
          </div>
          <vs-button color="danger" class="w-full" @click="closePopup"
            >Ganti</vs-button
          >
        </div></vs-popup
      >
      <vs-popup
        color="danger"
        title="Update Password"
        :is-valid="validName"
        :active.sync="activePrompt2"
        button-close-hidden
        @close="closePopup">
        <div class="con-exemple-prompt">
          <p
            v-if="!validName"
            class="py-2 px-5 my-3 bg-danger rounded-lg text-white">
            {{ validErrorMsg }}
          </p>
          <div style="position: relative">
            <vs-input
              data-vv-validate-on="blur"
              v-validate="'required|min:1|max:15'"
              :type="show_pwd.value1 ? 'text' : 'password'"
              name="password"
              icon="icon icon-lock"
              icon-pack="feather"
              label-placeholder="Password"
              v-model="valMultipe.value1"
              class="w-full mt-8 no-icon-border" />
            <div
              @click="show_pwd.value1 = !show_pwd.value1"
              style="
                position: absolute;
                right: 10px;
                top: 9px;
                cursor: pointer;
              ">
              <feather-icon
                icon="EyeIcon"
                v-if="show_pwd.value1"
                svgClasses="h-4 w-4" />
              <feather-icon
                icon="EyeOffIcon"
                v-if="!show_pwd.value1"
                svgClasses="h-4 w-4" />
            </div>
          </div>
          <div style="position: relative">
            <vs-input
              data-vv-validate-on="blur"
              v-validate="'required|min:1|max:15'"
              :type="show_pwd.value2 ? 'text' : 'password'"
              name="password_baru"
              icon="icon icon-lock"
              icon-pack="feather"
              label-placeholder="Password baru"
              v-model="valMultipe.value2"
              class="w-full mt-8 no-icon-border" />
            <div
              @click="show_pwd.value2 = !show_pwd.value2"
              style="
                position: absolute;
                right: 10px;
                top: 9px;
                cursor: pointer;
              ">
              <feather-icon
                icon="EyeIcon"
                v-if="show_pwd.value2"
                svgClasses="h-4 w-4" />
              <feather-icon
                icon="EyeOffIcon"
                v-if="!show_pwd.value2"
                svgClasses="h-4 w-4" />
            </div>
          </div>
          <div style="position: relative">
            <vs-input
              data-vv-validate-on="blur"
              v-validate="'required|min:1|max:15'"
              :type="show_pwd.value3 ? 'text' : 'password'"
              name="konfirmasi_password_baru"
              icon="icon icon-lock"
              icon-pack="feather"
              label-placeholder="Konfirmasi Password Baru"
              v-model="valMultipe.value3"
              class="w-full mt-8 no-icon-border" />
            <div
              @click="show_pwd.value3 = !show_pwd.value3"
              style="
                position: absolute;
                right: 10px;
                top: 9px;
                cursor: pointer;
              ">
              <feather-icon
                icon="EyeIcon"
                v-if="show_pwd.value3"
                svgClasses="h-4 w-4" />
              <feather-icon
                icon="EyeOffIcon"
                v-if="!show_pwd.value3"
                svgClasses="h-4 w-4" />
            </div>
          </div>
          <div class="flex flex-row-reverse mt-5" style="gap: 5px">
            <vs-button
              class="w-full"
              color="danger"
              :disabled="!validName"
              @click="updateForm"
              >Submit</vs-button
            >
          </div>
        </div>
      </vs-popup>
    </div> -->
    <div class="vx-navbar-wrapper" style="height: 80px">
      <vs-navbar
        class="vx-navbar navbar-custom"
        :color="navbarColor"
        :class="classObj">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden md:hidden sm:hidden cursor-pointer mr-1"
          icon="MenuIcon"
          @click.stop="showSidebar"></feather-icon>

        <template v-if="breakpoint != 'sm'">
          <!-- STARRED PAGES - FIRST 10 -->
          <ul
            class="vx-navbar__starred-pages hidden md:block sm:block vs-con-loading__container menu_loading">
            <draggable
              v-model="starredPagesLimited"
              :group="{ name: 'pinList' }"
              class="flex cursor-move">
              <li class="starred-page">
                <img
                  src="../../assets/images/logo/logo.png"
                  alt=""
                  style="height: 25px; margin-top: 4px; margin-right: 2px" />
              </li>
              <li
                class="starred-page"
                :key="indextr"
                v-for="(list, indextr) in menu_parent">
                <vs-dropdown
                  vs-custom-content
                  class="cursor-pointer"
                  v-if="list.menu_link == '#'">
                  <span class="cursor-pointer flex i18n-locale">
                    <feather-icon
                      svgClasses="h-6 w-6"
                      class="p-2 cursor-pointer"
                      :icon="list.menu_icon"></feather-icon>
                  </span>
                  <vs-dropdown-menu class="w-48 i18n-dropdown">
                    <div class="notification-top text-center p-3">
                      <h6>{{ $t(list.menu_name) }}</h6>
                    </div>
                    <vs-divider class="m-1"></vs-divider>
                    <ul style="min-width: 9rem">
                      <li
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                        v-for="child in getChild(list)"
                        @click="$router.push(child.menu_link)">
                        <feather-icon
                          icon="ChevronRightIcon"
                          svgClasses="w-4 h-4"></feather-icon>
                        <span class="ml-2">{{ $t(child.menu_name) }}</span>
                      </li>
                    </ul>
                  </vs-dropdown-menu>
                </vs-dropdown>
                <vx-tooltip
                  :text="$t(list.menu_name)"
                  position="bottom"
                  delay=".3s"
                  v-if="list.menu_link != '#' && list.parent_id == ''">
                  <feather-icon
                    :id="list.menu_icon"
                    svgClasses="h-6 w-6"
                    class="p-2 cursor-pointer"
                    :icon="list.menu_icon"
                    @click="$router.push(list.menu_link)"></feather-icon>
                </vx-tooltip>
              </li>
            </draggable>
          </ul>
        </template>
        <vs-spacer></vs-spacer>

        <!-- I18N -->

        <!-- SEARCHBAR -->

        <!-- CART DROPDOWN -->

        <!-- @deprecated Test popup alert -->
        <!-- <vs-button class="me-3" @click="testPuAlert">
          <div>TEST</div>
        </vs-button> -->

        <!-- VOLUME -->
        <!-- <vs-dropdown vs-custom-content class="cursor-pointer">
          <Volume2Icon class="cursor-pointer mt-1 sm:mr-6 mr-2"></Volume2Icon>
          <vs-dropdown-menu class="">
            <div class="flex flex-row items-center mx-5" style="gap: 10px">
              <Volume1Icon class="mt-1 sm:mr-6 mr-2"></Volume1Icon>
              <input
                type="range"
                min="1"
                max="100"
                value="50"
                class="slider"
                id="myRange" />
              <Volume2Icon class="mt-1 sm:mr-6 mr-2"></Volume2Icon>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown> -->

        <!-- LANGUAGE DROPDOWN -->
        <vs-dropdown vs-custom-content class="cursor-pointer mr-5">
          <div class="con-img ml-3">
            <img
              :src="getCurrentLocaleData.flag"
              alt="user-img"
              width="30"
              height="30"
              class="rounded-full shadow-md cursor-pointer block" />
          </div>
          <vs-dropdown-menu>
            <ul style="min-width: 9rem">
              <li
                v-for="lang in languages"
                class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                @click="updateLocale(lang.locale)">
                <img
                  :src="lang.flag"
                  alt="us"
                  width="20"
                  height="20"
                  class="rounded-full shadow-md cursor-pointer block" />
                <span class="ml-2">{{ lang.lang }}</span>
              </li>
            </ul>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- NOTIFICATIONS -->
        <vs-dropdown
          v-if="getRolePermission().alert.alert_history.access_to_alert"
          vs-custom-content
          class="cursor-pointer"
          color="danger">
          <feather-icon
            icon="BellIcon"
            class="cursor-pointer mt-1 sm:mr-6 mr-2"
            :badge="counter"></feather-icon>
          <vs-dropdown-menu
            class="notification-dropdown dropdown-custom dropdown-red"
            color="danger">
            <div class="notification-top text-center p-5 bg-danger text-white">
              <h3 class="text-white">{{ counter }} New</h3>
              <p class="opacity-75">{{ $t('Vehicle Notifications') }}</p>
            </div>

            <VuePerfectScrollbar
              ref="mainSidebarPs"
              class="scroll-area--nofications-dropdown p-0 mb-10"
              :settings="settings">
              <ul class="bordered-items">
                <li
                  v-for="ntf in data_notif"
                  class="flex justify-between px-4 py-4 notification"
                  style="position: relative">
                  <div class="flex items-start">
                    <feather-icon
                      class="cursor-pointer"
                      @click="$router.push('/alert-history')"
                      icon="AlertTriangleIcon"
                      :svgClasses="[
                        `text-danger`,
                        'stroke-current mr-1 h-6 w-6',
                      ]"></feather-icon>
                    <div
                      @click="$router.push('/alert-history')"
                      class="mx-2 cursor-pointer">
                      <span
                        class="font-medium block notification-title"
                        :class="[`text-danger`]"
                        >{{ ntf.license_plate }}</span
                      >
                      <small>{{ ntf.event_name }}</small>
                    </div>
                  </div>
                  <!--<vs-button v-show="hideBtn != ntf._id" style="transform: scale(0.65);position: absolute;bottom: 0;right: -9px;" class="mt-2 btn-sm float-right btn-load-1 vs-con-loading__container" @click="validate(ntf)">-->
                  <!--<feather-icon icon="CheckCircleIcon" svgClasses="h-4 w-4"></feather-icon> Verify-->
                  <!--</vs-button>-->
                  <!--<div v-show="hideBtn == ntf._id" style="color:#1c44a3;position: absolute;bottom: 8px;right: 12px;font-size: 12px;">-->
                  <!--Verifying ...-->
                  <!--</div>-->
                  <small class="mt-1 whitespace-no-wrap">{{
                    elapsedTime(ntf.device_time)
                  }}</small>
                </li>
              </ul>
            </VuePerfectScrollbar>
            <div
              @click="navigateToAll"
              class="checkout-footer fixed pin-b rounded-b-lg text-primary w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid border-grey-light cursor-pointer">
              <span>{{ $t('View All Notification') }}</span>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ user_displayName }}</p>
            <small>{{ user_role }}</small>
          </div>
          <vs-dropdown vs-custom-content class="cursor-pointer">
            <div class="con-img ml-3">
              <!--<img-->
              <!--v-if="activeUserImg.startsWith('http')"-->
              <!--key="onlineImg"-->
              <!--:src="activeUserImg"-->
              <!--alt="user-img"-->
              <!--width="40"-->
              <!--height="40"-->
              <!--class="rounded-full shadow-md cursor-pointer block" />-->
              <img
                key="localImg"
                :src="ProfilePic"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block" />
            </div>
            <vs-dropdown-menu>
              <ul style="min-width: 9rem">
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="logout">
                  <feather-icon
                    icon="LogOutIcon"
                    svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Logout</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue'
import PuAlert from './popup-alert/PuAlert.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import draggable from 'vuedraggable'
import * as REPO from '../../repository/index'
import { mapState } from 'vuex'
import ProfilePic from '../../assets/Icon-baru/AFMS-ProfilePic.png'
import moment from 'moment'
import { socket } from '@/socket'

import en from '../../assets/images/flags/en.png'
import id from '../../assets/images/flags/id.png'
import de from '../../assets/images/flags/de.png'
import fr from '../../assets/images/flags/fr.png'
import pt from '../../assets/images/flags/pt.png'

const localStorageKey = 'loggedIn'
const tokenExpiryKey = 'tokenExpiry'
import axios from 'axios'
import { Volume1Icon, Volume2Icon, VolumeIcon } from 'vue-feather-icons'

const alertPermissions = [
  // urgent
  {
    alert: 'Accident Event',
    permission: 'accident',
    type: 'urgent',
  },
  {
    alert: 'Geofence In',
    permission: 'geofence_in',
    type: 'urgent',
  },
  {
    alert: 'Geofence Out',
    permission: 'geofence_out',
    type: 'urgent',
  },
  {
    alert: 'Over Stay Engine On',
    permission: 'overstay_engine_on',
    type: 'urgent',
  },
  {
    alert: 'Over Stay Engine Off',
    permission: 'overstay_engine_off',
    type: 'urgent',
  },
  {
    alert: 'Main Battery Disconnected (Power Loss)',
    permission: 'main_battery_disconnected',
    type: 'urgent',
  },
  // summary
  {
    alert: 'Over Speed',
    permission: 'overspeed',
    type: 'summary',
  },
  {
    alert: 'Harsh Brake',
    permission: 'harsh_break',
    type: 'summary',
  },
  {
    alert: 'Harsh Acceleration',
    permission: 'harsh_acceleration',
    type: 'summary',
  },
]

export default {
  name: 'the-navbar',
  props: {
    navbarColor: {
      type: String,
      default: '#fff',
    },
  },
  data() {
    return {
      languages: [
        { lang: 'English', flag: en, locale: 'en' },
        { lang: 'Indonesia', flag: id, locale: 'id' },
        // { lang: 'German', flag: de, locale: 'de' },
        // { lang: 'French', flag: fr, locale: 'fr' },
        // { lang: 'Portuguese', flag: pt, locale: 'pt' },
      ],
      ProfilePic: ProfilePic,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: '',
      waktuCek: null,
      waktuCekSession: null,
      counter: '',
      hideBtn: null,
      menu_data: [],
      data_notif: [],
      menu_parent: [],
      showFullSearch: false,
      unreadNotifications: [
        {
          index: 'lalala',
          license_plate: 'B1850UIB',
          msg: 'hehe',
          time: 'Wed Jan 30 2019 07:45:23 GMT+0000 (GMT)',
        },
      ],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,

      activePrompt1: false,
      activePrompt2: false,
      valMultipe: {
        value1: '',
        value2: '',
        value3: '',
      },
      show_pwd: {
        value1: false,
        value2: false,
        value3: false,
      },
      validErrorMsg: 'Lengkapi data untuk melanjutkan',
    }
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
    },
    // '$i18n.locale'() {
    //
    // },
  },
  created() {
    // const fleet_group_id = JSON.parse(
    //   localStorage.getItem('userInfo')
    // ).fleet_group_id
    const fleet_group_ids = JSON.parse(
      localStorage.getItem('userInfo')
    ).fleet_group_ids
    //
    //
    const permissions = this.getRolePermission()
    //
    if (permissions.alert.alert_pop_up_notification.pop_up_notification) {
      JSON.parse(fleet_group_ids).forEach((fleet_group_id) => {
        socket.addEventListener(fleet_group_id, (event) => {
          let data = event.body
          //

          // check if the specific alert is allowed to be shown from the permissions object
          const tmpPermission = alertPermissions.find(
            (x) => x.alert == event.title
          )

          const is_allowed =
            permissions.alert[tmpPermission.type][tmpPermission.permission]

          if (!is_allowed) return

          const type = event.title
          //
          let detail = ''
          switch (type) {
            case 'Over Speed':
              detail = data.speed
              break

            default:
              detail = 0
              break
          }
          const content = {
            component: PuAlert,
            props: {
              alert_id: data.index,
              initialTime: new Date(data.time).getTime(),
              license_plate: data.license_plate,
              msg: type,
              detail: detail,
              fleet_group: data.fleet_group_name,
            },
          }

          this.$toast(content, {
            icon: '',
            timeout: 10000,
            onClick: () => {
              if (this.$route.path != '/alert-history') {
                this.$router.push('/alert-history')
                setTimeout(() => {
                  this.$root.$emit('filterNotifBawah', data.license_plate)
                }, 1500)
              }
              this.$root.$emit('filterNotifBawah', data.license_plate)
            },
          })
        })
      })
    }
  },
  mounted() {
    let self = this
    this.activePrompt1 = this.getMonthlyChange()
    axios.interceptors.response.use(
      function (response) {
        let expire = localStorage.getItem('expired')

        if (response.data.status == 'false') {
          if (
            response.data.error_msg == 'JWT Token Expired' ||
            response.data.error_msg == 'User not Found'
          ) {
            if (self.waktuCek == null) {
              self.waktuCek = moment()
              self.$toast.error('Your login session ended')
              self.logout()
            } else {
              let now = moment()
              let past = moment(self.waktuCek)
              let perbedaan = now.diff(past, 'seconds')
              //
              //

              if (Math.abs(parseInt(perbedaan)) > 4) {
                self.$toast.error('Your login session ended')
                self.logout()
              }
              self.waktuCek = moment()
            }
          }
        } else {
          let url = false
          url = response.config.url.includes('/api/mw-mapping-history/alert')
          let now = moment()
          let tgl_akhir = moment(expire)
          var duration = moment.duration(tgl_akhir.diff(now))
          var minutes = duration.asMinutes()
          if (parseInt(minutes) < 15 && parseInt(minutes) > 0 && !url) {
            if (self.waktuCekSession == null) {
              self.waktuCekSession = moment()
              //
              REPO.refreshToken().then((result) => {
                let payload = {
                  expired_date: result.data.data.expired_date,
                  token: result.data.data.token,
                }
                self.$store.dispatch('auth/reloadStorage', payload)
                location.reload()
              })
            } else {
              let now = moment()
              let past = moment(self.waktuCekSession)
              let perbedaan = now.diff(past, 'seconds')

              if (Math.abs(parseInt(perbedaan)) > 10) {
                //
                //
                self.waktuCekSession = moment()
                REPO.refreshToken().then((result) => {
                  let payload = {
                    expired_date: result.data.data.expired_date,
                    token: result.data.data.token,
                  }
                  self.$store.dispatch('auth/reloadStorage', payload)
                  location.reload()
                })
              }
            }
          }
        }
        return response
      },
      function (error) {
        // Do something with response error
        //
        return Promise.reject(error)
      }
    )
    this.$store.watch(
      (state) => {
        return this.$store.getters.getAllAlert
      },
      (val) => {
        //
      },
      {
        deep: true,
      }
    )

    //

    this.$store.watch(
      (state) => state.notifData,
      (oldValue, newValue) => {
        Permissions
        //
        this.counter = self.$store.getters['getCounter']()
        let listAlert = self.$store.getters['getHundredAlert']()
        // let newData = [];
        // listAlert.forEach(z=>{
        //     newData.push(z.body);
        // });
        this.data_notif = listAlert
      }
    )
    //
    this.$vs.loading({
      container: `.menu_loading`,
      scale: 0.45,
    })

    Array.prototype.move = function (from, to) {
      this.splice(to, 0, this.splice(from, 1)[0])
    }

    Array.prototype.swapItems = function (a, b) {
      this[a] = this.splice(b, 1, this[a])[0]
      return this
    }

    REPO.getListMenu().then((res) => {
      let menus = JSON.parse(localStorage.getItem('userInfo')).role.role_menu
      let master_menu = res.data.data
      this.menu_data = []
      master_menu.forEach((x) => {
        let tmp = menus.filter((y) => {
          return x.id == y.menu_id
        })
        if (tmp.length > 0) {
          this.menu_data.push(x)
        }
        if (x.menu_name == 'Configurations') {
        }
      })
      //
      this.menu_parent = this.menu_data.filter((x) => {
        return x.parent_id == ''
      })
      const home = this.menu_parent.findIndex((x) => {
        return x.menu_name == 'Dashboard'
      })
      if (home > -1 && home != 0) {
        this.menu_parent.move(home, 0)
      }
      // const overviewIndex = this.menu_data.findIndex((x) => {
      //   return x.menu_name == 'Overview'
      // })
      // const analyticsIndex = this.menu_data.findIndex((x) => {
      //   return x.menu_name == 'Analytics'
      // })
      // //
      // if (overviewIndex > -1 && analyticsIndex > -1) {
      //   this.menu_data.swapItems(overviewIndex, analyticsIndex)
      // }
      // const isLiveTrack = this.menu_parent.findIndex((x) => {
      //   return x.menu_name == 'Live View'
      // })
      // if (isLiveTrack > -1) {
      //   this.menu_parent.move(isLiveTrack, 1)
      // }
      this.$vs.loading.close(`.menu_loading > .con-vs-loading`)
    })
  },
  computed: {
    // HELPER
    validName() {
      const self = this
      const isValid =
        this.valMultipe.value1 !== '' &&
        this.valMultipe.value2 !== '' &&
        this.valMultipe.value3 !== ''

      if (this.valMultipe.value2 !== this.valMultipe.value3) {
        this.validErrorMsg =
          'Password baru dan konfirmasi password baru tidak sama'

        return false
      }
      if (self.valMultipe.value1 === self.valMultipe.value2) {
        self.validErrorMsg =
          'Password baru tidak boleh sama dengan password lama'

        return false
      }

      return isValid
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth
    },
    breakpoint() {
      return this.$store.state.breakpoint
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == 'default') return 'navbar-default'
      else if (this.sidebarWidth == 'reduced') return 'navbar-reduced'
      else if (this.sidebarWidth) return 'navbar-full'
    },

    // I18N
    getCurrentLocaleData() {
      const locale = this.$i18n.locale
      return this.languages.find((x) => x.locale == locale)
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList
    },
    starredPages() {
      return this.$store.state.starredPages
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10)
      },
      set(list) {
        this.$store.dispatch('arrangeStarredPagesLimited', list)
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10)
      },
      set(list) {
        this.$store.dispatch('arrangeStarredPagesMore', list)
      },
    },

    // CART DROPDOWN
    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse()
    },

    // PROFILE
    user_displayName() {
      return JSON.parse(localStorage.getItem('userInfo')).name
    },
    menu_list() {
      return JSON.parse(localStorage.getItem('userInfo')).role.role_menu
    },
    user_role() {
      return JSON.parse(localStorage.getItem('userInfo')).role.role_name
    },
    activeUserImg() {
      return (
        JSON.parse(localStorage.getItem('userInfo')).photoURL ||
        this.$store.state.AppActiveUser.img
      )
    },
  },
  methods: {
    logout() {
      // let user_id = JSON.parse(localStorage.getItem('userInfo')).id
      // REPO.lgoutUser({ user_id }).then((res) => {
      // disconnect socket
      // socket.disconnect()
      // this.$auth.logOut()
      localStorage.removeItem('userInfo')
      localStorage.removeItem('userData')
      localStorage.removeItem('token')
      localStorage.removeItem('expired')
      this.$router.push('/pages/login')
      // Change role on logout. Same value as initialRole of acj.js
      // this.$acl.change('admin')
      localStorage.removeItem('userRole')
      // })
    },
    closePopup(value) {
      this.activePrompt1 = false
      this.activePrompt2 = true
    },
    updateForm() {
      // this.loadingBtnStart('btn-load-2')
      this.$vs.loading({
        container: `.con-exemple-prompt`,
        scale: 0.45,
      })
      let dataForm = {
        name: this.$dataLocal.UserData().name,
        email: this.$dataLocal.UserData().email,
        no_telp: this.$dataLocal.UserData().no_telp,
        role_id: this.$dataLocal.UserData().role_id,
        is_active: this.$dataLocal.UserData().is_active,
        old_password: this.valMultipe.value1,
        password: this.valMultipe.value2,
        // fleet_group_id: this.$dataLocal.UserData().fleet_group_id,
        // updated_by: this.$dataLocal.UserData().name,
      }
      // if (this.new_password !== '') {
      //   dataForm.password = this.new_password
      // }

      REPO.updateUser(dataForm, this.$dataLocal.UserData().id)
        .then((res) => {
          // this.clearFields()
          // this.loadingBtnStop('btn-load-2')
          // this.$emit('submitModal', false)
          this.$vs.loading.close(`.con-exemple-prompt > .con-vs-loading`)
          this.$toast.success('Data Successfully Submitted')
          this.logout()
          // logout
        })
        .catch((err) => {
          //
          // this.loadingBtnStop('btn-load-2')
          this.$toast.error(err.message)
          this.$vs.loading.close(`.con-exemple-prompt > .con-vs-loading`)
        })
        .finally(() => {})
    },
    acceptAlert(color) {
      this.$vs.notify({
        color: 'success',
        title: 'Accept Selected',
        text: 'Lorem ipsum dolor sit amet, consectetur',
      })
    },
    close() {
      this.$vs.notify({
        color: 'danger',
        title: 'Closed',
        text: 'You close a dialog!',
      })
    },
    testPuAlert() {
      //
      this.unreadNotifications.map((x) => {
        // this.$store.dispatch('addAlert', x)
        // const content = {
        //   component: PuAlert,
        //   props: {
        //     alert_id: 'lalala',
        //     initialTime: new Date(x.time).getTime(),
        //     license_plate: x.title,
        //     msg: x.msg,
        //     icon: x.icon,
        //   },
        // }
        const content = {
          component: PuAlert,
          props: {
            alert_id: x.index,
            initialTime: new Date(x.time).getTime(),
            license_plate: x.license_plate,
            msg: x.msg,
          },
        }
        this.$toast(content, {
          icon: '',
          timeout: 10000,
          onClick: () => {
            //
            this.$router.push('/alert-history')
          },
        })
      })
    },
    validate(val) {
      this.hideBtn = val._id
      let name = JSON.parse(localStorage.getItem('userInfo')).name
      let data = {
        imei: val.imei,
        verified_date: moment().format('YYYY-MM-DD HH:mm'),
        verified_by: name,
      }
      REPO.updateAlertHistory(data, val._id).then((res) => {
        this.$emit('validateData', true)
        //
        //
        this.$root.$emit('reloadNotifBawah')
        this.$toast.success('Verifying Success')
      })
    },
    navigateToAll() {
      this.$router.push('/alert-history')
    },
    getChild(val) {
      let tmp = this.menu_data.filter((x) => {
        return x.parent_id == val.id
      })
      return tmp
    },
    updateLocale(locale) {
      this.$i18n.locale = locale
    },
    showSidebar() {
      this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true)
    },
    selected(item) {
      this.$router.push(item.url)
      this.showFullSearch = false
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch('updateStarredPage', {
        index: item.index,
        val: !item.highlightAction,
      })
    },
    showNavbarSearch() {
      this.showFullSearch = true
    },
    showSearchbar() {
      this.showFullSearch = true
    },
    elapsedTime(startTime) {
      let x = new Date(startTime)
      let now = new Date()
      var timeDiff = now - x
      timeDiff /= 1000

      var seconds = Math.round(timeDiff)
      timeDiff = Math.floor(timeDiff / 60)

      var minutes = Math.round(timeDiff % 60)
      timeDiff = Math.floor(timeDiff / 60)

      var hours = Math.round(timeDiff % 24)
      timeDiff = Math.floor(timeDiff / 24)

      var days = Math.round(timeDiff % 365)
      timeDiff = Math.floor(timeDiff / 365)

      var years = timeDiff

      if (years > 0) {
        return years + (years > 1 ? ' Years ' : ' Year ') + 'ago'
      } else if (days > 0) {
        return days + (days > 1 ? ' Days ' : ' Day ') + 'ago'
      } else if (hours > 0) {
        return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago'
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago'
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? `sec ago` : 'just now')
      }

      return 'Just Now'
    },
    logout() {
      let user_id = JSON.parse(localStorage.getItem('userInfo')).id
      REPO.lgoutUser({ user_id }).then((res) => {
        // disconnect socket
        socket.disconnect()
        this.$auth.logOut()
        localStorage.removeItem('userInfo')
        localStorage.removeItem('expired')
        this.$router.push('/pages/login')
        // Change role on logout. Same value as initialRole of acj.js
        this.$acl.change('admin')
        localStorage.removeItem('userRole')
      })
    },
    outside: function () {
      this.showBookmarkPagesDropdown = false
    },

    // CART DROPDOWN
    removeItemFromCart(item) {
      this.$store.dispatch('eCommerce/toggleItemInCart', item)
    },
  },
  directives: {
    'click-outside': {
      bind: function (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind: function (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      },
    },
  },
  components: {
    VxAutoSuggest,
    VuePerfectScrollbar,
    draggable,
    VolumeIcon,
    Volume1Icon,
    Volume2Icon,
  },
}
</script>

<style lang="scss">
.dropdown-red > .vs-dropdown--menu--after {
  background: #ea5354 !important;
}

.starred-page {
  padding: 0 3px;
}

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(
    .large
  ).vs-button-border {
  padding: 0.679rem 1rem;
}

.Vue-Toastification__container.top-right.my-container-class {
  top: 4em;
}
</style>
